module.exports = __webpack_public_path__ + "static/logo-6f124f0296f5b5e3aa08a19808b5a0d1.svg";